// extracted by mini-css-extract-plugin
module.exports = {"iframe":"add-data_iframe__1LYEC"};